<script lang="ts">
import type { Icon } from '@/types'

type Props = {
	icon: Icon
}

let { icon }: Props = $props()

const SvelteComponent = $derived(icon)
</script>

<span class="icon">
	<SvelteComponent width="1em" height="1em" />
</span>

<style lang="postcss">
.icon {
	@apply relative inline-block p-2 bg-primary-button text-primary-button-content rounded-3xl;
}
</style>
